export default class GlobalCoverage {
  constructor() {
    this.getDomElements()

    if (!this.dom.input || !this.dom.select || !this.dom.wrapper || !this.dom.items.length) return
    
    this.init()
  }

  init() {
    this.elements = []

    this.dom.items.forEach(item => {
      this.elements.push({
        'element' : item,
        'region' : item.dataset.region,
        'name' : item.dataset.name,
      })
    })

    this.handleChanges()
  }

  handleChanges() {
    this.dom.select.addEventListener('change', () => {
      this.filterResults()
    })

    this.dom.input.addEventListener('keyup', () => {
      this.filterResults()
    })
  }

  filterResults() {
    // Reset
    this.dom.wrapper.innerHTML = ''

    // Get Filter Values
    let region = this.dom.select.value
    let search = this.dom.input.value

    // Reset each time we filter to our cached value
    let results = this.elements

    // Filter our results
    if (region) {
      results = results.filter(element => element.region == region)
    }

    if (search.length) {
      results = results.filter(element => element.name.toLowerCase().includes(search.toLowerCase()))
    }

    if (results.length) {
      results.forEach(element => this.dom.wrapper.appendChild(element.element))
    } else {
      this.noResults()
    }
  }

  noResults() {
    this.dom.wrapper.innerHTML = '<h3 clas="e-heading e-heading--three e-heading--italic e-heading--bold e-heading--black">No Results Found</h3>'
  }

  getDomElements() {
    this.dom = {
      'input' : document.querySelector('.js-country-filter'),
      'select' : document.querySelector('.js-region-filter'),
      'wrapper' : document.querySelector('.js-countries'),
      'items' : document.querySelectorAll('.js-country')
    }
  }
}